import { render, staticRenderFns } from "./explainArticle.vue?vue&type=template&id=9d9f5cfa&scoped=true&"
import script from "./explainArticle.vue?vue&type=script&lang=js&"
export * from "./explainArticle.vue?vue&type=script&lang=js&"
import style0 from "./explainArticle.vue?vue&type=style&index=0&id=9d9f5cfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d9f5cfa",
  null
  
)

export default component.exports